export default __webpack_public_path__ + "b39f8a4547bd914c22dc753608f0854f.svg";